import { render, staticRenderFns } from "./MobileDepartmentMenu.vue?vue&type=template&id=dc6db4b2&"
import script from "./MobileDepartmentMenu.vue?vue&type=script&lang=js&"
export * from "./MobileDepartmentMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports